module.exports = __webpack_public_path__ + "static/media/nickles3.5ead114f.jpg";